// Copyright © 2024 Move Closer

import { IEventbus } from '@movecloser/front-core'
import { Component, Inject, Prop } from 'vue-property-decorator'

import { Link } from '../../../dsl/front'
import { AnyModule, ContentSneakPeakData } from '../../_contracts'
import { AddonsMixin } from './AddonsMixin'
import { ListTileConfig } from '../Tile'

/**
 * Shared interface for merged list items in list components with addons
 */
export interface MergedListItem {
  type: 'article' | 'addon';
  data: ContentSneakPeakData | AnyModule;
  position: number;
  key: string;
}

/**
 * Base mixin for list components that support addons mixed within articles
 * Provides common functionality for handling addons and merged item lists
 */
@Component({
  name: 'ListWithAddonsMixin'
})
export class ListWithAddonsMixin extends AddonsMixin {
  /**
   * Articles to be rendered.
   */
  @Prop({ type: Array, required: false, default: () => [] })
  public readonly items!: MergedListItem[]

  /**
   * "Read more" link.
   */
  @Prop({ type: Object, required: false })
  public readonly readMoreLink?: Link

  @Inject({ from: 'eventBus' })
  private readonly eventBus!: IEventbus

  /**
   * ArticlesList Config.
   */
  @Prop({ type: Object, required: false, default: () => ({ showArticleTags: false }) })
  public readonly listConfig?: ListTileConfig
}
